export default () => ({
  commissions: {},
});
